export const deleteCondition = (conditions, conditionId) => {
  let newConditions = conditions.filter(condition => condition.id !== conditionId);
  const lastCondition = newConditions.pop();

  if (lastCondition) return [...newConditions, {...lastCondition, condition: null}];
  return conditions;
};